/*
  SIGNATURE JUDGE.ME REVIEW COUNT

  Desktop (1000px up, 3 cards per row): 6 cards before "Incarca mai mult". Judge.me loads 3 reviews per page, so once
  its widget is set up the script asks for the next page once, through Judge.me's own button; after a sort, which
  renders a fresh list, it does it again. Nothing happens when Judge.me already loads 6 or more, or has no next page.

  Mobile (below 700px): only the first 3 cards show: this script marks the widget .signature-jdgm-limited while more than 3 cards are loaded,
  which hides the rest and Judge.me's own "Incarca mai mult" (assets/signature-judgeme.css), and adds the theme's
  button after the widget. A click shows every loaded card and hands over to Judge.me's button, which loads the next
  page. The button sits outside Judge.me's markup, which Judge.me re-renders on sort and on load more; the label
  comes from the script tag (layout/theme.liquid, product.general.reviews_load_more).
*/
(() => {
  const LIMIT = 3;
  const DESKTOP_COUNT = 6;
  const desktop = window.matchMedia('(min-width: 1000px)');
  const label = document.currentScript?.dataset.loadMore || '';

  const fill = (widget) => {
    const list = widget.querySelector('.jdgm-rev-widg__reviews');
    const button = widget.querySelector('.jdgm-paginate__load-more');

    if (!desktop.matches || !list || !button || list.dataset.signatureFilled || !widget.classList.contains('jdgm--done-setup-widget')) {
      return;
    }

    const count = list.querySelectorAll('.jdgm-rev').length;

    if (count > 0 && count < DESKTOP_COUNT) {
      list.dataset.signatureFilled = 'true';
      button.click();
    }
  };

  const update = (widget) => {
    fill(widget);

    const count = widget.querySelectorAll('.jdgm-rev-widg__reviews .jdgm-rev').length;
    const limited = count > LIMIT && !widget.classList.contains('signature-jdgm-expanded');
    widget.classList.toggle('signature-jdgm-limited', limited);

    let more = widget.nextElementSibling;

    if (!more || !more.classList.contains('signature-jdgm-more')) {
      if (!limited) {
        return;
      }

      more = document.createElement('div');
      more.className = 'signature-jdgm-more';

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--xl';
      button.textContent = label;
      button.addEventListener('click', () => {
        widget.classList.add('signature-jdgm-expanded');
        update(widget);
      });

      more.append(button);
      widget.after(more);
    }

    more.hidden = !limited;
  };

  // Judge.me renders and re-renders the widget on its own schedule; batched with a timeout, not
  // requestAnimationFrame, which never runs in a hidden tab.
  let queued = false;
  const scan = () => {
    if (queued) {
      return;
    }

    queued = true;
    setTimeout(() => {
      queued = false;
      document.querySelectorAll('.jdgm-widget.jdgm-review-widget').forEach(update);
    }, 50);
  };

  // A shopper's click on Judge.me's own button (shown while 3 or fewer cards are loaded) means they want more: the cards
  // it loads must not be hidden again. The desktop fill's click is not a shopper's (isTrusted false).
  document.addEventListener('click', (event) => {
    const widget = event.target.closest?.('.jdgm-paginate__load-more')?.closest('.jdgm-widget.jdgm-review-widget');

    if (widget && event.isTrusted) {
      widget.classList.add('signature-jdgm-expanded');
    }
  }, true);

  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  desktop.addEventListener('change', scan);
  scan();
})();
